import React, { useState, useCallback, useRef } from 'react';
import styles from './styles/ScenarioTitlePageTags.module.css';

const ScenarioTitlePageTags = ({ tags, setTags }) => {
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef(null);
    const MAX_TAGS = 6;

    const handleRemoveTag = useCallback(
        (tagToRemove) => {
            setTags((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
        },
        [setTags]
    );

    const handleAddTag = useCallback(
        (event) => {
            const value = inputValue.trim().toLowerCase();
            if ((event.key === ' ' || event.key === ',') && value) {
                event.preventDefault();
                if (!tags.includes(value) && tags.length < MAX_TAGS) {
                    setTags((prevTags) => [...prevTags, value]);
                }
                setInputValue('');
            }
            if (event.key === 'Enter' && value) {
                event.preventDefault();
                 if (!tags.includes(value) && tags.length < MAX_TAGS) {
                    setTags((prevTags) => [...prevTags, value]);
                }
                setInputValue('');
            }
            if (event.key === 'Backspace' && !inputValue && tags.length > 0) {
                setTags((prevTags) => prevTags.slice(0, -1));
            }
        },
        [tags, inputValue, setTags]
    );

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const focusInput = () => {
        inputRef.current?.focus();
    };

    return (
        <div className={styles.tagsWrapper}>
            <h2 className={styles.sectionTitle}>Tags</h2>
            <p className={styles.helperText}>
                Add up to {MAX_TAGS} tags. Press Space, Comma, or Enter after each tag.
            </p>
            <div
                className={`${styles.tagsInputContainer} ${isFocused ? styles.focused : ''}`}
                onClick={focusInput}
                onKeyDown={(e) => e.key === 'Enter' && focusInput()}
                role="textbox"
                tabIndex={0}
            >
                {tags.map((tag, index) => (
                    <div key={index} className={styles.tagPill}>
                        <span className={styles.tagText}>{tag}</span>
                        <button
                            type="button"
                            className={styles.removeTagButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveTag(tag);
                            }}
                            aria-label={`Remove tag ${tag}`}
                        >
                            ×
                        </button>
                    </div>
                ))}
                <input
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={handleAddTag}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    ref={inputRef}
                    className={styles.actualTagInput}
                    placeholder={tags.length === 0 ? "Add a tag..." : ""}
                    aria-label="Add a new tag"
                    spellCheck="false"
                />
            </div>
            <div className={styles.detailsFooter}>
                <p className={styles.tagsRemainingText}>
                    <span>{Math.max(0, MAX_TAGS - tags.length)}</span> tags remaining
                </p>
                {tags.length > 0 && (
                    <button
                        type="button"
                        onClick={() => {
                            setTags([]);
                            inputRef.current?.focus();
                        }}
                        className={`${styles.button} ${styles.clearAllButton}`}
                    >
                        Clear All
                    </button>
                )}
            </div>
        </div>
    );
};

export default React.memo(ScenarioTitlePageTags);